import React, { useState, useEffect } from "react";
import { GridList } from "@material-ui/core";
import { GridListTile } from "@material-ui/core";
import { Travel, Wedding, Business, babyshoot, personal, Family, Maternity, prewedding, Other } from "./photos"
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import swal from "sweetalert";
import "./imgGallery.css"

function ImgGallery(props) {
    const map = {
        "Travel": Travel,
        "Baby Shoot": babyshoot,
        "Business": Business,
        "Personal": personal,
        "Wedding": Wedding,
        "Family": Family,
        "Maternity": Maternity,
        "Pre-wedding": prewedding,
        "Other": Other
    }
    const [imgPack, setImgPack] = useState(Travel);
    const getGridListCols = () => {
        // console.log(window.innerWidth);
        let col = 2, cHeight = 250, cellWidth = 0;
        if (window.innerWidth < 768) {
            col = 1;
            cHeight = 205;
            cellWidth = 1;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            col = 2;
            cHeight = 275;
        } else {
            col = 3;
            cHeight = 375;
        }
        return { col, cHeight, cellWidth };
    }
    const col_height = getGridListCols();
    const cellHeight = col_height.cHeight;
    const colss = col_height.col;
    const cellWidth = col_height.cellWidth;
    // console.log(imgPack.length, Math.ceil(imgPack.length/3), Math.ceil(2*imgPack.length/3))

    const handleRightClick=(e)=>{
        e.preventDefault();
    }

    const fetchPhotos=(type)=>{
        fetch(`https://api.fodrix.com/portfolio/get-portfolio-image-by-type/${type}`)
        .then(response=>{
            if (response.ok) {
                return response.json()
            } else {
                swal("", "Something went wrong!", "error");
            }
        })
        .then(data=>{console.log(data)})
        .catch(err=>{console.error(err)})
    }

    useEffect(() => {
        if (props.packImg) {
            fetchPhotos(props.packImg);
            setImgPack(map[props.packImg]);
            console.log(map[props.packImg]);
        }
    }, [props.packImg])

    useEffect(() => {
        if (props.packImg) {
            setImgPack(map[props.packImg]);
            console.log(map[props.packImg]);
        }
    }, [imgPack])

    return (
        <>
            {/* <GridList  spacing={10} cols={colss || 2} cellHeight={cellHeight || 250}>
                {
                    imgPack && imgPack.map((obj, id) => {
                        return (
                            <GridListTile 
                            key={id} 
                            cols={cellWidth || (obj.cols || 1)}
                            rows={obj.rows || 1}
                            // style={{flexGrow:'1'}}
                            >
                                <img loading="lazy" className="portfolio-grid-img" src={obj.src} alt={`Image ${id}`} />
                            </GridListTile>
                        )
                    })
                }
            </GridList> */}

            {/* <div class="img_gal_container">

                {
                    Wedding && Wedding.map((pack, id) => {
                        return (
                            <div key={id} className="img_container">
                                <img loading="lazy" src={pack.src} alt="portfolio" />
                            </div>
                        )
                    })
                }
            </div> */}

            <div class="portfolio_row">
                <div class="portfolio_column">
                    {
                        imgPack && imgPack.slice(0,  Math.ceil(imgPack.length/3)).map((pack, id) => {
                            return (
                                <img onContextMenu={(e)=>{e.preventDefault()}} loading="lazy" src={pack.src} alt="portfolio" />
                            )
                        })
                    }
                </div>
                <div class="portfolio_column">
                    {
                        imgPack && imgPack.slice( Math.ceil(imgPack.length/3),  Math.ceil(2*imgPack.length/3)).map((pack, id) => {
                            return (
                                <img  onContextMenu={(e)=>{e.preventDefault()}} loading="lazy" src={pack.src} alt="portfolio" />
                            )
                        })
                    }
                </div>
                <div class="portfolio_column">
                    {
                        imgPack && imgPack.slice(Math.ceil(2*imgPack.length/3), imgPack.length).map((pack, id) => {
                            return (
                                <img  onContextMenu={(e)=>{e.preventDefault()}} loading="lazy" src={pack.src} alt="portfolio" />
                            )
                        })
                    }

                    {/* <img src="/w3images/wedding.jpg"/>
                    <img src="/w3images/rocks.jpg"/>
                    <img src="/w3images/falls2.jpg"/>
                    <img src="/w3images/paris.jpg"/>
                    <img src="/w3images/nature.jpg"/>
                    <img src="/w3images/mist.jpg"/>
                    <img src="/w3images/paris.jpg"/> */}
                </div>
            </div>




        </>
    )
}

export default withWidth()(ImgGallery);